// product video

   $(document).on("click", ".product-video-icon .video-control", function() {

       var clickedControl = $(this).parents('.video-item');
       var clickedVideo = clickedControl.find('video')[0];
       var videoHtml = clickedControl.find('.video-show').html();
       // Move the video to the main popup
       $('.main-product-popup').html(videoHtml);

       // Pause all other videos
       $('.video-popup-content video').not(clickedVideo).each(function() {
           this.pause();
           $(this).siblings('.video-control').removeClass('btnhide');
       });

       // Toggle play/pause and update control icon for the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo.paused) {
           mainPopupVideo.play();
           $('.main-product-popup .video-control').addClass('btnhide');
       } else {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       // Activate the main popup
       $('.main-product-popup').addClass('video-active');
       $('body').addClass('video-popup-active');
   });

     $(document).on("click", ".main-product-popup .icon-close", function() {
       // Pause and close the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.main-product-popup').removeClass('video-active');
       $('.main-product-popup').empty();
  });

   $(document).on("click", ".main-product-popup .icon-volume", function() {
   console.log("this = ", this);
   	var mainPopupVideo = $(this).parents('.main-product-popup').find('video')[0];
   	console.log("mainPopupVideo", mainPopupVideo);
   	if (mainPopupVideo) {
   		mainPopupVideo.muted = !mainPopupVideo.muted;
   		$(this).toggleClass("volume-muted", mainPopupVideo.muted);
   	}
   });

$(document).ready(function() {
    // Select the video elements
    var video1 = $('#video-poster-1 video')[0];
var video2 = $('#video-poster-2 video')[0];

if (video1 && video2) {
    // Function to start playing video 1 and stop video 2
    function playVideo1() {
        video2.pause();
        video2.currentTime = 0; // Optional: Reset video 2 to the start
        video1.play();
        setTimeout(function() {
            playVideo2();
        }, 4000); // Wait for 4 seconds before switching to video 2
    }

    // Function to start playing video 2 and stop video 1
    function playVideo2() {
        video1.pause();
        video1.currentTime = 0; // Optional: Reset video 1 to the start
        video2.play();
        setTimeout(function() {
            playVideo1();
        }, 4000); // Wait for 4 seconds before switching back to video 1
    }

    // Start the loop with video 1
    playVideo1();
}
});



// product faq accordion
$(document).on('click', '.product-faq-text-icon', function () {
  var $item = $(this).closest('.product-faq-item');
  $('.product-faq-item').not($item).removeClass('active').find('.product-faq-content').slideUp(300);
  $item.toggleClass('active').find('.product-faq-content').slideToggle(300);
});



document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".subscription-toggle");
  const productForm = document.querySelector('form[action="/cart/add"]');
  const widget = document.querySelector(".custom-subs-widget");

  if (!toggle || !productForm) return;

  /* -----------------------
     HELPERS
  ----------------------- */

  function getSelectedVariantId() {
    const checked = document.querySelector(".bundle-swatch-item-input:checked");
    return checked ? checked.dataset.varId : null;
  }

  function getVariantRow(vid) {
    return document.querySelector(`.variants_data li[data-vid="${vid}"]`);
  }

  function parseMoney(val) {
    if (!val) return 0;
    return parseFloat(val.replace(/[^0-9.]/g, "")) || 0;
  }

  /* -----------------------
     SELLING PLAN (CRITICAL FIX)
  ----------------------- */

  function applySellingPlan() {
    let input = productForm.querySelector('input[name="selling_plan"]');

    if (toggle.classList.contains("active")) {
      const spid = widget?.dataset.spid;
      if (!spid) return;

      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "selling_plan";
        productForm.appendChild(input);
      }

      input.value = spid;
    } else {
      if (input) input.remove();
    }
  }

  /* -----------------------
     PRICE UPDATE
  ----------------------- */

  function updatePrices() {
    const isSub = toggle.classList.contains("active");

    document.querySelectorAll(".bundle-swatch-item-input").forEach((input) => {
      const vid = input.dataset.varId;
      const row = getVariantRow(vid);
      if (!row) return;

      const wrapper = input.closest(".bundle-swatch-item-image-text");
      const priceEl = wrapper?.querySelector(".product-price");
      if (!priceEl) return;

      const normal = parseMoney(row.dataset.price);
      const sub = parseMoney(row.dataset.subprice);

      const finalPrice = isSub && sub > 0 ? sub : normal;
      priceEl.textContent = `$${finalPrice.toFixed(2)}`;
    });
  }

  /* -----------------------
     REFRESH
  ----------------------- */

  function refreshAll() {
    applySellingPlan();
    updatePrices();
  }

  /* -----------------------
     EVENTS
  ----------------------- */

  toggle.addEventListener("click", function () {
    toggle.classList.toggle("active");
    refreshAll();
  });

  document.querySelectorAll(".bundle-swatch-item-input").forEach((radio) => {
    radio.addEventListener("change", refreshAll);
  });

  /* -----------------------
     INIT (DEFAULT ON)
  ----------------------- */

  toggle.classList.add("active");
  refreshAll();
});
// $(document).on("click", ".bundle-swatch-item-input", function () {
//     var variantId = $(this).data('varId');

//     // // Find the matching <option> in the delivery-frequency select
//     var $option = $('#delivery-frequency option[variantid="' + variantId + '"]').css('border','1px solid');
//     // if (!$option.length) return;

//     // // Get the selling plan ID
//     // var sellingPlanID = $option.val();

//     // // Get subscription price from hidden li
//     // var $liData = $('.variants_data li[data-vid="' + variantId + '"]');
//     // var subPrice = $liData.data('subprice');

//     // // Set values in the product form
//     // $('form.product-form input[name="selling_plan"]').val(sellingPlanID);
//     // $('form.product-form input.product-variant-id').val(variantId);

//     console.log('Variant ID:', variantId);
//     console.log('Selling Plan ID:', sellingPlanID);
//     console.log('Subscription Price:', subPrice);

// });
// $(document).on("click", ".bundle-swatch-item-input", function () {
//   var datavariantId = $(this).attr("data-var-id");
//   console.log("datavariantId:", datavariantId);

//   // Remove outline from all frequency buttons
//   $(".delivery-frequency-select button").css("outline", "none");

//   // Get the correct button for this variant
//   var $button = $('.delivery-frequency-select button[variantid="' + datavariantId + '"]').first();

//   if ($button.length) {
//     var planId = $button.val();

//     // Set selling plan input
//     $('.product-form input[name="selling_plan"]').val(planId);

//     //   var $liData = $('.variants_data li[data-vid="' + datavariantId + '"]');

//     // if ($liData.length) {
//     //     var subPrice = $liData.data("subprice"); // e.g. ₹1299 or 1299

//     //     if (subPrice) {
//     //     $(".bundle-swatch-item-price-text").css('border','1px solid');
//     //     $(".product-price").text(subPrice);
//     //     }
//     // }
//     var $liData = $('.variants_data li[data-vid="' + datavariantId + '"]');
//     if ($liData.length) {
//         var subPrice = $liData.data("subprice"); // "$26.98", "$40.48", "$53.98"

//         if (subPrice) {
//             var $priceWrap = $(".bundle-swatch-item-price-text");
//             var $priceText = $(".product-price");

//             // Update price text
//             $priceText.text(subPrice);

//            if ($('.subscription-toggle').hasClass('active')) {
//     // Add temporary highlight via click
//     $('.subscription-toggle').trigger('click');

//     // Remove highlight after short delay
//     setTimeout(function () {
//         $('.subscription-toggle').trigger('click');
//     }, 1000);
// }
//         }
//      }
//     }
// });
// $(document).on("click", ".bundle-swatch-item-input", function () {
//   var datavariantId = $(this).attr("data-var-id");
//   console.log("datavariantId:", datavariantId);

//   // Remove outline from all frequency buttons
//   $(".delivery-frequency-select button").css("outline", "none");

//   // Get the correct button for this variant
//   var $button = $('.delivery-frequency-select button[variantid="' + datavariantId + '"]').first();

//   if ($button.length) {
//     var planId = $button.val();

//     // Delay setting the selling plan input by 2 seconds
//     setTimeout(function() {
//       $('.product-form input[name="selling_plan"]').val(planId);
//       console.log("Selling plan updated after delay:", planId);
//     }, 1200); // 2000ms = 2 seconds

//     // Update price immediately
//     var $liData = $('.variants_data li[data-vid="' + datavariantId + '"]');
//     if ($liData.length) {
//       var subPrice = $liData.data("subprice"); // "$26.98", "$40.48", etc.

//       if (subPrice) {
//         // $(".product-price").text(subPrice);

//         // Temporary subscription toggle highlight (instant)
//         if ($('.subscription-toggle').hasClass('active')) {
//           $('.subscription-toggle').trigger('click');
//           setTimeout(function () {
//             $('.subscription-toggle').trigger('click');
//           }, 1000); // fast flash (0.5s)
//         }
//       }
//     }
//   }
// });
$(document).ready(function () {
  $(document).on("click", ".bundle-swatch-item-image-text", function () {
    bundleproduct(this);
  });

  function bundleproduct(el) {
    const $swatches = $('.bundle-swatch-item-image-text');

    // Remove active class from all swatches
    $swatches.filter('.active').removeClass('active');

    // Set active swatch
    const $this = $(el).addClass('active');

    // Get variant ID
    const variantId = $this
    .find('.bundle-swatch-item-input')
    .data('var-id');

    // Mark product as selected
    $this
    .closest('.product__info-container')
    .addClass('has-selection');

    // Update variant ID for add-to-cart
    $('.product-form input[name="id"]').val(variantId);

    // Match selling plan (subscription)
    const $wrapper = $(
    '.variant-frequency-wrapper[data-variant-id="' + variantId + '"]'
    );

    if ($wrapper.length) {
    const planId = $wrapper.find('button').val();
    $('.product-form input[name="selling_plan"]').val(planId);
    } else {
    // Clear selling plan if none exists
    $('.product-form input[name="selling_plan"]').val('');
    }

    // Re-enable pointer events (if they were disabled elsewhere)
    setTimeout(() => {
    $swatches.css('pointer-events', '');
    }, 100);
  }
})


document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector(".product-sticky-form");
  if (!stickyForm) return;

  function handleSticky() {
    const scrollTop = window.scrollY;
    const isDesktop = window.innerWidth >= 1024;

    const triggerPoint = isDesktop ? 800 : 1200;

    if (scrollTop > triggerPoint) {
      stickyForm.style.display = "block";
      stickyForm.classList.add("show");
    } else {
      stickyForm.classList.remove("show");

      setTimeout(() => {
        if (window.scrollY <= triggerPoint) {
          stickyForm.style.display = "none";
        }
      }, 400);
    }
  }

  window.addEventListener("scroll", handleSticky);
  window.addEventListener("resize", handleSticky);
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.querySelector(".product-form__add-button");
  const realSubmitBtn = document.querySelector(
    ".product-form .product-form__buttons .product-form__submit"
  );

  if (!stickyBtn || !realSubmitBtn) return;

  const text = stickyBtn.querySelector(".loader-button__text");
  const loader = stickyBtn.querySelector(".loading__spinner");

  stickyBtn.addEventListener("click", function (e) {
    e.preventDefault();

    // show loader
    if (text) text.style.display = "none";
    if (loader) loader.classList.remove("hidden");

    // trigger real add to cart
    realSubmitBtn.click();

    // hide loader after some time
    setTimeout(() => {
      if (text) text.style.display = "block";
      if (loader) loader.classList.add("hidden");
    }, 1500); // adjust time if needed
  });
});

